class t {
  constructor(e) {
    this._canceled = !1, this.data = e;
  }
  get type() {
    return this.constructor.type;
  }
  get cancelable() {
    return this.constructor.cancelable;
  }
  cancel() {
    this._canceled = !0;
  }
  canceled() {
    return this._canceled;
  }
  clone(e) {
    return new this.constructor({
      ...this.data,
      ...e
    });
  }
}
t.type = "event";
t.cancelable = !1;
export {
  t as AbstractEvent
};
